export default "__VITE_ASSET__DRDoZ90___"